<template>
 <v-btn @click="onConnect">Connect</v-btn>
</template>

<script>
import StravaAuth from '@/domain/StravaAuth';

export default {
  data: () => ({
  }),
  methods:
  {
    onConnect() {
      new StravaAuth().navigateOAuth();
    },
  },
};
</script>

<style>

</style>
